import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import {
  Agreement,
  AgreementDTOPayload,
  AgreementKPIsResponse,
  ProductDTO,
} from '@wilson/interfaces';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgreementsService extends BackendService<Agreement> {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'agreements';
  public addAgreementsToMultipleClients(
    agreements: Agreement[],
  ): Promise<Agreement[]> {
    return firstValueFrom(
      this.http.post<Agreement[]>(`${this.config.host}/${this.path}`, {
        items: agreements,
      }),
    );
  }

  bulkUpdateAgreements(agreements: Partial<Agreement[]>) {
    return firstValueFrom(
      this.http.patch(`${this.config.host}/${this.path}/bulk`, {
        items: agreements,
      }),
    );
  }

  createAgreement(
    agreement: Partial<AgreementDTOPayload>,
  ): Promise<Agreement[]> {
    return firstValueFrom(
      this.http.post<Agreement[]>(`${this.config.host}/${this.path}`, {
        items: [agreement],
      }),
    );
  }

  linkProductsToAgreements(
    agreementId: string,
    payload: { productIds: string[] },
  ): Observable<ProductDTO[]> {
    return this.http.post<ProductDTO[]>(
      `${this.config.host}/${this.path}/${agreementId}/products`,
      payload,
    );
  }

  getAggregatedAgreementKpi(
    agreementIds: string[],
  ): Observable<AgreementKPIsResponse> {
    return this.http.post<AgreementKPIsResponse>(
      `${this.config.host}/${this.path}/kpis`,
      { agreementIds },
    );
  }
}
